<template>
  <div>
    <div :class="orgInfo ? 'head' : 'head border'">
      <div class="bx-content">
        <div class="headBox">
          <div class="headLeft">
            <div v-if="orgInfo">
              <img :src="orgInfo.morglogo" alt="">
              <b>{{orgInfo.morgname}}专家智库系统</b>
            </div>
            <a href="http://zjzk.emof.cn/" v-else>
              <img :src="user.morgwlogo ? user.morgwlogo : logo"  alt="" >
            </a>
          </div>
          <div class="headRight">
            <div class='headRightTel flex align-center'>
              <div class="kefu">
                <img src="@/assets/images/phone.png" alt="">
                客服电话：{{ orgInfo ? orgInfo.tel : '400-999-6541'}}
              </div>
              <span class="guanb margin-right-xs" v-if="user" @click="sginout">退出</span>
              <span @click="to" class="check" v-if="orgInfo">申请入驻</span>
              <a :href="url +  str + '&path=home'" target="_blank" v-else><img src="@/assets/images/anniu.png" alt=""></a>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "headP",
  data() {
    return {
      logo:require('@/assets/images/logo.png'),
      url:'https://www.emof.cn/vw/tiaoz?code=',
      str:''
    }
  },
  props:{
    orgInfo:{
      type: Object,
      default: null
    },
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {},
  created() {
    if(this.user){
      this.str = this.user.emofUserTokenSafer
    }
  },
  methods: {
    // 跳转
    to() {
      this.$router.push({
        path: '/checkin',
        query: {
          register_type: 3,
          showId: this.orgInfo.showId
        }
      })
    },
    sginout() {
      this.$confirm(
          '您确定要退出吗？',
          '温馨提示', {
            confirmButtonText: '确定',
            type: 'warning',
            closeOnClickModal: false,
            closeOnPressEscape: false,
          }
      ).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.replace('/login')
        })
      })
    }
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.head {
  width: 100%;
  height: 80px;
  background-color: #0a2240;
  box-shadow: 0px 6px 18px 1px rgba(10, 34, 64, 0.45);

  display: flex;
  justify-content: space-between;
  align-items: center;
  &.border {
    border-bottom: 2px solid #C9C5C5;
  }
  .headBox {
    min-width: 1220px;
    width: 100%;
    margin: 0 auto;
    height: 70px;
    display: flex;
    justify-content: space-between;

    .headLeft {
      /*width: 90px;*/
      height: 70px;
      line-height: 70px;
      margin-left: -10px;

      img {
        height: 50px;
      }

      > div {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img {
          height: 64px;
        }
        b {
          font-size: 20px;
          color: #FFFFFF;
          margin-left: 20px;
        }
      }
    }


    .headRight {
      display: flex;
      justify-content: space-between;

      .headRightTel {
        font-size: 16px;
        height: 70px;
        color: #ffffff;
        line-height: 30px;
        background-size: 16px 16px;

        .kefu {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          font-size: 14px;
          letter-spacing: 1px;
          color: #f5f5f5;
          img {
            margin-right: 5px;
          }
        }

        .shux {
          margin: 0 10px;
        }

        .guanb {
          display: block;
          width: 99px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          background-color: #ff9600;
          border-radius: 20px;
          color: #fff;
          margin: 0 10px;
          cursor: pointer;
        }

        .check {
          display: block;
          width: 140px;
          height: 40px;
          background-image: linear-gradient(37deg,
            #ffb400 0%,
            #fc7802 100%),
          linear-gradient(
              #ff9600,
              #ff9600);
          background-blend-mode: normal,
          normal;
          border-radius: 20px;
          text-align: center;
          line-height: 40px;
          color: #fff;
          margin: 0 10px;
          cursor: pointer;
        }

        .xxzx {
          display: block;
          width: 99px;
          height: 40px;
          text-align: center;
          line-height: 38px;
          border-radius: 20px;
          border: solid 1px #ffffff;
          cursor: pointer;
          color: #fff;
          margin-left: 10px;
        }

        .jgsz {
          display: block;
          width: 99px;
          height: 40px;
          text-align: center;
          line-height: 38px;
          border-radius: 20px;
          border: solid 1px #ffffff;
          cursor: pointer;
          color: #fff;
        }

      }

      .headRightLogin {
        display: flex;
        justify-content: space-between;
        height: 40px;
        margin: 20px;

        div {
          height: 30px;
          line-height: 30px;
          font-size: 16px;
          color: #ffffff;
          margin-left: 3px;
        }

        .headRightDl {
          height: 30px;
          line-height: 30px;
          font-size: 16px;
          color: #ffffff;
          margin: 0 5px;

          .headIcon {
            width: 30px;
            height: 30px;
            border-radius: 15px;
            vertical-align: middle;
            margin-right: 5px;

          }
        }

        .headRightZc {
          width: 137px;
          height: 38px;
          background-color: #ffffff;
          border-radius: 19px;
          text-align: center;
          line-height: 38px;
          color: #0089ff;
          font-size: 16px;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>


